export const HOME_ALL_DATA = 'homeAllData'